const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Semantic Multi Select component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('suSelect', ['$timeout', function ($timeout) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      options: '=',
      selected: '=',
      loading: '=?',
      active: '=?',
      dropName: '@',
      forceTextNotDefault: '=?',
      disabledItems: '=?',
      trackSaved: '&?',
      cohortSelect: '=?',
    },
    template: require('../../templates/directives/su-select.html'),
    link: function (scope, element, attrs) {
      scope.select = {
        selection: null,
        previousSelection: null,
        menuClick: function() {
          if (this.open) {
            this.open = false;
            this.openBlock = {};
            return;
          }
          this.open = true;
          this.openBlock = {'display': 'block'};
        },
        selectItem: function(item) {
          var self = this;
          if (self.selection && self.selection === self.previousSelection) {
            self.selection = {};
            $timeout(function() {
              self.selection = item;
              self.previousSelection = item;
              scope.$apply();
            }, 1);
            return;
          }
          self.selection = item;
          self.previousSelection = item;
        }
      };

      var setSelections = function() {
        var directory = {};
        // exit if no options for some reason
        if(!scope.options) {
          return;
        }
        for (var i = 0; i < scope.options.length; i++) {
          directory[scope.options[i].value] = scope.options[i];
        }
        if (!scope.selected && scope.selected !== 0) {
          return;
        }
        for (var i = 0; i < scope.options.length; i++) {
          if (scope.options[i].value === scope.selected) {
            scope.select.selection = scope.options[i];
            break;
          }
        }

      };

      scope.$watch('select.selection', function(newVal, oldVal) {
        if (typeof newVal !== 'object' || newVal === oldVal) {
          return;
        }
        if (scope.selected !== scope.select.selection.value) {
          scope.selected = scope.select.selection.value;
        }
        if (scope.trackSaved) {
          scope.trackSaved();
        }
      }, true);

      var init = scope.$watch('options', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }

        if (oldVal) {
          return;
        }
        setSelections();
        init();
      });

      var initSelect = scope.$watch('selected', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }

        setSelections();
      });

      if (scope.options) {
        setSelections();
        init();
      }
    }
  }

}]);
